import * as _ from 'lodash';
import { AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, forwardRef, HostListener, Input, OnInit, ViewChild } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-jquery-select-control',
  templateUrl: './jquery-select-control.component.html',
  styleUrls: ['./jquery-select-control.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => JquerySelectControlComponent),
    multi: true,
  }],
})
export class JquerySelectControlComponent implements OnInit, AfterViewInit, ControlValueAccessor {

  @ViewChild('select') select: ElementRef<HTMLSelectElement>;

  @Input() list = [];
  @Input() label = '';

  @Input() selectClasses = [];
  @Input() labelClasses = [];

  @HostListener('click', ['$event']) onClick = (event) => {
    event.preventDefault();
    event.stopPropagation();
  };

  private html = '';

  constructor() { }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    this.html = '';
    for(let i = 0; i < this.list.length; i++) {
      const element = this.list[i];
      this.html += `<option value='${element.id}'>${element.name}</option>`;
    }
    if(this.select) {
      this.materialSelect();
    }
  }

  materialSelect(): void {
    const $ = window['$'];
    const { select: { nativeElement } } = this;
    const select = $(nativeElement);

    select.html(this.html);
    select.materialSelect({destroy: true});
    select.materialSelect();

    select.change(({ target }) => {
      const element = _.find(this.list, ({ id }) => id === target.value) || null;
      this.onChangeCallback(element);
    });

    select.val(this.list[0].id).change();
  }

  private onChangeCallback = (value: any) => {};
  private onTouchedCallback = () => {};

  registerOnChange(fn: any) {
    this.onChangeCallback = fn;
  }

  registerOnTouched(fn: () => {}): void {
    this.onTouchedCallback = fn;
  }

  writeValue(value) {
  }

}
